<template>
  <div v-show="isAppLauncherEnabled" ref="appLauncherBtn"></div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import {
  createAppLauncherButton,
  getIsAppLauncherEnabled,
} from '@attensi/app-launcher'

const isAppLauncherEnabled = ref(false)
const appLauncherBtn = ref<HTMLDivElement | null>(null)

onMounted(async () => {
  if (appLauncherBtn.value) {
    createAppLauncherButton(appLauncherBtn.value)
    isAppLauncherEnabled.value = await getIsAppLauncherEnabled()
  }
})
</script>
